<div class="load__animation" *ngIf="showAnimation$ | async">
  <img src="assets/animations/animation-load.svg" alt="" />
</div>

<div class="request-access-page" *ngIf="!(showAnimation$ | async)">
  <div class="request-access-page__image"></div>
  <div class="request-access-page__form">
    <div class="form-container" [formGroup]="requestAccessForm" [@errorFormAnimation]="requestAccessError">
      <div class="logo-section">
        <div class="logo"></div>
        <div class="sub-logo">{{ 'SERVICE_PORTAL' | translate }}</div>
      </div>

      <div class="header-section">
        {{ 'REQUEST_ACCESS' | translate }}
      </div>

      <div *ngIf="!(requestAccessSuccess$ | async)">
        <div class="inputs-section">
          <div class="requestorName">
            <app-input
              formControlName="requestorName"
              [control]="requestorName"
              [isInvalid]="!!requestorName.errors && !requestorName.pristine"
              [label]="'REQUESTOR_NAME_LABEL' | translate"
              [isServerError]="isServerError"
              [placeholder]="'REQUESTOR_NAME_PLACEHOLDER' | translate"
            >
            </app-input>
          </div>

          <div class="requestorEmail">
            <app-input
              formControlName="requestorEmail"
              [control]="requestorEmail"
              [isInvalid]="!!requestorEmail.errors && !requestorEmail.pristine"
              [label]="'REQUESTOR_EMAIL_LABEL' | translate"
              [isServerError]="isServerError"
              [placeholder]="'REQUESTOR_EMAIL_PLACEHOLDER' | translate"
            >
            </app-input>
          </div>

          <div class="requestorCompany">
            <app-input
              formControlName="requestorCompany"
              [control]="requestorCompany"
              [isInvalid]="!!requestorCompany.errors && !requestorCompany.pristine"
              [label]="'REQUESTOR_COMPANY_LABEL' | translate"
              [isServerError]="isServerError"
              [placeholder]="'REQUESTOR_COMPANY_PLACEHOLDER' | translate"
            >
            </app-input>
          </div>
        </div>

        <div class="button-section">
          <app-button
            (triggered)="handleCaptcha()"
            *ngIf="!(requestAccessLoading$ | async)"
            [size]="'large'"
            [filled]="true"
            [disabled]="requestAccessForm.invalid"
          >
            {{ 'SEND_ACCESS_REQUEST' | translate }}
          </app-button>
          <div class="load__animation" *ngIf="requestAccessLoading$ | async">
            <img src="assets/animations/animation-load.svg" alt="" />
          </div>
        </div>
      </div>

      <div *ngIf="requestAccessSuccess$ | async">
        <div class="inputs-section">
          <div>{{ 'ACCESS_REQUEST_SENT' | translate }}</div>
          <div>{{ 'ACCESS_REQUEST_CONTACT' | translate }}</div>
        </div>

        <div class="button-section">
          <a class="login" routerLink="/login">{{ 'LOG_IN' | translate }}</a>
        </div>
      </div>
    </div>
    <div class="version">v{{ appVersion }}</div>
  </div>
</div>

<ngx-invisible-recaptcha
  *ngIf="!(requestAccessSuccess$ | async)"
  #captchaElem
  [siteKey]="siteKey"
  (success)="handleSuccess($event)"
  (expire)="handleExpire()"
  (error)="handleError()"
  [ngModel]="recaptcha"
  [ngModelOptions]="{ standalone: true }"
>
</ngx-invisible-recaptcha>
